import { TimelineMax, TweenLite } from "gsap";
import { IDimConfig, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../../SanGameConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SpinePlayer } from "../../../../proto/SpinePlayer";
import { SoundConfig } from "../../../../SoundConfig";
import { SoundManager } from "../../../../resource/sound/SoundManager";

export class SplashViewFreeSpins extends BaseView implements SplashView  {

    private _spine:SpinePlayer;
    
    protected layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(0.75, 0.75),
                position: new PIXI.Point(360, 300),
                layout: {
                    left: new PIXI.Point(360, 300),
                    right: new PIXI.Point(360, 300)
                }
            },
            portrait: {
                scale: new PIXI.Point(0.75, 0.75),
                position: new PIXI.Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };

    protected _timeLine:TimelineMax;

    protected DEFAULT_TXT_STYLE:TextStyleOptions;

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
        this.visible = false;
    }

    protected initAnimations():void{

        this._spine = this.addChild(new SpinePlayer("fs_Intro"));

        StageManager.getLayer(SanGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    public play():TimelineMax{
        this.visible = true;
        this.alpha = 1;
        this.onResize();
        SoundManager.playSoundEffect(SoundConfig.instance.FS_INTRO);
        const tl:TimelineMax = this._spine.play( { name:"FS_Intro_" + this.introVal, showOnEnd:true } );
        return tl;
    }

    private introVal:number = 1;
    parseResult(val:number){
        this.introVal = val;
    }

    public stop():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax({onComplete:() => this.visible = false}));
        this._timeLine.to(this,0.35,{alpha:0});
        return this._timeLine;
    }

    public onResize():void{
        if(this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);

        const isLand:boolean =  ResizeHelper.IsLandscape();

        this.scale = ResizeHelper.calcDim(this.layoutDim).scale;
       
        this._spine.scale.set(isLand ? 1 : 1/0.75);
        this._spine.y = isLand ? 400 : 360;
        this._spine.x = (isLand ? 480 : 360)*this._spine.scale.x;
    }
}
